<fieldset [formGroup]="group" class="in-two-columns">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- Format -->

  <mat-form-field>
    <app-easy-select
      formControlName="format"
      [label]="TITLE + 'TEA_FORMAT' | translate"
      [translatePrefixForSelected]="'PRODUCTS.TEA_FORMAT.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="format | toSelectOption: 'PRODUCTS.TEA_FORMAT.'"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !Format -->

  <!-- Preparation procedure -->

  <mat-form-field>
    <app-easy-select
      formControlName="preparationProcedure"
      [label]="TITLE + 'PREPARATION_PROCEDURE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.TEA_PREPARATION_PROCEDURE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="
        preparationProcedure
          | toSelectOption: 'PRODUCTS.TEA_PREPARATION_PROCEDURE.'
      "
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !Preparation procedure -->

  <!-- Type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'TEA_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.TEA_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="type | toSelectOption: 'PRODUCTS.TEA_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- !Type -->
</fieldset>
